import { Iconic } from '@/commons/iconic';
import { useCompanyCategory } from '@/hooks/useCompanyCategory';
import { translates } from '@/utils';
import { Card, Button, Typography, CardHeader, CardContent } from '@mui/material';

type Props = {
  billing: any | null;
  enableEdit?: boolean;
};

export default function CheckoutBillingInfo({ billing, enableEdit }: Props) {
  const { isFoodCompany } = useCompanyCategory();
  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader
        title={translates.accountInformation}
        action={
          enableEdit && (
            <Button size="small" startIcon={<Iconic icon="eva:edit-fill" />} onClick={() => null}>
              {translates.edit}
            </Button>
          )
        }
      />
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          {billing?.table && isFoodCompany ? [translates.table] : [translates.client]}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {billing?.table || billing?.customer?.name}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          {isFoodCompany ? translates.waiter : 'Vendedor'}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {billing?.vendor?.name}
        </Typography>
      </CardContent>
    </Card>
  );
}
